import React, { useMemo } from "react";
import { useSelector } from "react-redux";

import { useParams } from "react-router-dom";
import { selectDraftBoardForm } from "../../../../components/Settings/redux/selector";
import { GroupByTypeEnum } from "../../../../types";
import { ITickets } from "../../types";
import { useTicketFieldUpdate } from "../useTicketFieldUpdate";
import FieldRenderer from "./FieldRenderer";

interface Props {
  ticket: ITickets;
  className?: string;
}

const TicketCustomize: React.FC<Props> = ({ ticket, className }) => {
  const boardData = useSelector(selectDraftBoardForm);
  const { project } = useParams<{ project: string }>();

  const { handleUpdate } = useTicketFieldUpdate(ticket._id, project as string);
  // ✅ Visible fields
  const activeFields = useMemo<GroupByTypeEnum[]>(
    () =>
      boardData?.customizeCards
        ?.filter((f) => !f?.disabled && f?.isVisible && f?.type)
        ?.map((v) => v.type as GroupByTypeEnum) ?? [],
    [boardData?.customizeCards],
  );

  return (
    <div className={`${className} flex flex-col w-full`}>
      {activeFields.map((field) => (
        <FieldRenderer
          key={field}
          field={field}
          ticket={ticket}
          onUpdate={handleUpdate}
        />
      ))}
    </div>
  );
};

export default TicketCustomize;
